
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gJIlQk9J8SgrRpl5oopB2PuweezyNW9aZ43YmPViNHcUMeta } from "/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as index2syvL6eNycz9B_pi6GwXqTnr5L0RocXNQQorNVq5CmkMeta } from "/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchjpwXkS9rt1NvJxzV3tOS_45RELTFtgJNx43diD1LID6LMMeta } from "/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexQgUv6dG_SjwGss0EXZwXEyMK9SnbODguGmMH02GF8JsMeta } from "/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93NL8YYavdZG_45I5Jj0AMrKvb_45HINa2FT4r0gN3NWcx1FwMeta } from "/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexItnemnn2oTqnW1vdkNZTsr2ENgxDGBcRrTSzaAy8yFMMeta } from "/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93gjf2eKA0TAxzdq_45Y1KZxwc5_45KLFv_YK8kqADQTLDIv0Meta } from "/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexFhfJ3_ANkLu4jUs4HJDPkjiPWpHyfR1dGyxCdbjzT20Meta } from "/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93lr9BFgyJ_451KAsVguL9PgG1ddq6AD1bdUSG_45Ht5bwWUoMeta } from "/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexK5aEtpF58JnTY86H0LOga8dY2x_45PWUp1U90mDeY2_cwMeta } from "/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexvTmoxKZyK1eht5_9OA_8_456wyg0F6IqcJUbAlmgucF8MMeta } from "/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexItnemnn2oTqnW1vdkNZTsr2ENgxDGBcRrTSzaAy8yFMMeta || {},
    component: () => import("/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexFhfJ3_ANkLu4jUs4HJDPkjiPWpHyfR1dGyxCdbjzT20Meta || {},
    component: () => import("/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexK5aEtpF58JnTY86H0LOga8dY2x_45PWUp1U90mDeY2_cwMeta || {},
    component: () => import("/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexvTmoxKZyK1eht5_9OA_8_456wyg0F6IqcJUbAlmgucF8MMeta || {},
    component: () => import("/codebuild/output/src2695863113/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]